import { render, staticRenderFns } from "./abnormalRelease.vue?vue&type=template&id=004bca22&scoped=true"
import script from "./abnormalRelease.vue?vue&type=script&lang=js"
export * from "./abnormalRelease.vue?vue&type=script&lang=js"
import style0 from "./abnormalRelease.vue?vue&type=style&index=0&id=004bca22&prod&scoped=true&lang=css"
import style1 from "./abnormalRelease.vue?vue&type=style&index=1&id=004bca22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004bca22",
  null
  
)

export default component.exports